import { useState } from 'react'

import { AUDIT_PERMISSIONS } from '@/lib/permissions'
import { usePermissions } from '@/lib/use-permissions'
import { Button } from '@/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from '@/ui/dialog'

import { SubjectAuditLog } from '../subject-audit-log/subject-audit-log'

export function UserAuditLog({ entityId, userId, userName }: { entityId: string; userId: string; userName: string }) {
  const { can } = usePermissions()
  const [open, setOpen] = useState(false)
  if (!can(AUDIT_PERMISSIONS.read)) return null
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)}>Audit log</Button>
      <DialogContent className="flex max-h-[90vh] max-w-6xl flex-col overflow-y-auto">
        <DialogTitle>Audit log for {userName}</DialogTitle>
        <DialogDescription>Recorded changes and activity for this user in this organization and its children, newest first.</DialogDescription>
        {open ? (
          <div className="flex min-h-96 flex-1 flex-col overflow-hidden">
            <SubjectAuditLog
              entityId={entityId}
              subjectType="User"
              subjectId={userId}
              urlState={false}
              caption={`Audit entries for ${userName}`}
            />
          </div>
        ) : null}
        <DialogFooter><Button size="sm" variant="outline" onClick={() => setOpen(false)}>Close</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
